import React from 'react';
import SearchCommandsInfo from '../../../voxel/Search/SearchCommandsInfo';
import VoxelAdvancedTextSearch from '../../../voxel/Search/VoxelAdvancedTextSearch';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';
import HeadCell from './HeadCell';
import HeadCellStandardOptions from './HeadCellStandardOptions';
import VoxelMenuItemContainer from '../../../voxel/PopoverMenu/VoxelMenuItemContainer';

export interface HeadCellTextProps extends HeadCellImplementationProps {
  filterState?: string;
  setFilterState?: (state: string) => void;
  skipInfoIcon?: boolean;
}

export const HeadCellText: React.FC<HeadCellTextProps> = ({
  filterState,
  setFilterState,
  basicConfig,
  basicState,
  skipInfoIcon,
}) => {
  return (
    <HeadCell
      hasFilter={!!filterState?.length}
      align={'left'}
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />
        <div className="p-3">
          <VoxelAdvancedTextSearch
            value={filterState}
            onChange={(event) => setFilterState(event.target.value)}
            autoFocus
            infoIcon={skipInfoIcon ? undefined : <SearchCommandsInfo />}
          />
        </div>
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellText;
